import { render, staticRenderFns } from "./AlertTriage.vue?vue&type=template&id=0294704a&scoped=true"
import script from "./AlertTriage.vue?vue&type=script&lang=js"
export * from "./AlertTriage.vue?vue&type=script&lang=js"
import style0 from "./AlertTriage.vue?vue&type=style&index=0&id=0294704a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0294704a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0294704a')) {
      api.createRecord('0294704a', component.options)
    } else {
      api.reload('0294704a', component.options)
    }
    module.hot.accept("./AlertTriage.vue?vue&type=template&id=0294704a&scoped=true", function () {
      api.rerender('0294704a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/home/AlertTriage.vue"
export default component.exports